<div class="flex flex-col gap-4">
	<div>
		<p class="text-lg">Review {{ title$ | async }}</p>
		<p class="text-gray-500 text-sm bg-white">
			Edit signer emails as needed; changes will sync with your matter.
		</p>
		<p class="text-gray-500 text-sm bg-white">
			Each signer must have at least one signing field assigned before you can
			send.
		</p>
	</div>

	<form [formGroup]="form">
		<app-e-signing-recipient-list
			[form]="form"
			[submitted_]="submitted_()"
			class="h-full"
			[recipients]="recipients"
		/>
	</form>
</div>
